import { SkeletonBlock } from './SkeletonBlock';

export const DappsSectionSkeleton = () => {
  return (
    <div className="px-2 pt-4 pb-2 flex flex-col justify-start items-start gap-2 w-full overflow-y-auto flex-1">
      <div className="w-40 h-5 relative px-2">
        <div className="opacity-70 text-white text-xs font-semibold uppercase leading-tight tracking-tight">
          DAPPS
        </div>
      </div>

      <div className="flex flex-col justify-start items-start w-full">
        {[1, 2].map((index) => (
          <div key={index} className="w-full">
            <div className="w-60 h-9 px-2 py-3.5 rounded inline-flex justify-start items-center gap-2">
              <div className="flex justify-start items-center gap-1">
                <SkeletonBlock className="size-4 rounded" />
              </div>
              <div className="rounded-full flex justify-start items-center gap-2">
                <SkeletonBlock className="size-6 rounded-lg" />
              </div>
              <div className="flex-1">
                <SkeletonBlock
                  className={
                    index === 1
                      ? 'h-3.5 w-[60px] rounded'
                      : 'h-3.5 w-[75px] rounded'
                  }
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
